import { jsx, jsxs } from "react/jsx-runtime";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useMediaQuery, Dialog, Slide, styled, Grid, TextField, Switch } from "@mui/material";
import _cloneDeep from "lodash/cloneDeep";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import React__default, { useState, useEffect, useMemo } from "react";
import { searchProductsRest } from "../../api/utils.js";
import brandclub_colors from "../../colors/brandclubColors.js";
import { AppCheckbox } from "../../Components/AppCheckbox/index.js";
import { SearchIcon } from "../../icons/SearchIcon.js";
import { brandclubStyles } from "../../styles/index.js";
import { FilterParam, getFilterParamKeyFromValue } from "../../types/filters.js";
import { searchParamsToSearchFilters } from "../SearchResults/searchResultsUtils.js";
import { TABLET_SCREEN_SIZE } from "../../utils/constants/Constants.js";
import { Button } from "../../Components/Button/Button.js";
const SHOW_MORE_INITIAL_LIMIT = 6;
const SHOW_MORE_LIMIT = 100;
const BrandclubFilterSwitch = styled((props) => /* @__PURE__ */ jsx(
  Switch,
  {
    checkedIcon: /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          width: 14,
          height: 14,
          borderRadius: 100,
          backgroundColor: "#fff",
          alignItems: "center",
          display: "flex",
          justifyContent: "center"
        },
        children: /* @__PURE__ */ jsx(
          CheckRoundedIcon,
          {
            sx: (theme) => ({
              color: theme.vars.palette.text.primary,
              width: 12,
              height: 12
            })
          }
        )
      }
    ),
    focusVisibleClassName: ".Mui-focusVisible",
    disableRipple: true,
    ...props
  }
))(({ theme }) => ({
  width: 30,
  height: 20,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 3,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(10px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.vars.palette.primary.main,
        opacity: 1,
        border: 0
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5
      }
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff"
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "grey"
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3
    }
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 14,
    height: 14,
    boxShadow: "none"
  },
  "& .MuiSwitch-track": {
    borderRadius: 100,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 300
    })
  }
}));
const Transition = React__default.forwardRef(function Transition2(props, ref) {
  return /* @__PURE__ */ jsx(Slide, { direction: "up", ref, ...props });
});
const FilterHeader = styled(Grid)(({ theme }) => ({
  fontFamily: "Poppins",
  color: theme.vars.palette.text.primary,
  padding: "21px 30px",
  display: "grid",
  gridTemplateColumns: "50px auto 50px",
  width: 690,
  borderBottom: `1px solid ${brandclub_colors.blueWhite}`,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    width: "100%",
    ".center": { fontSize: 16 },
    ".right": {
      fontSize: 14
    }
  },
  ".left": {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center"
  },
  ".center": {
    fontSize: 18,
    fontWeight: 600,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  ".right": {
    fontSize: 16,
    fontWeight: 500,
    color: theme.vars.palette.text.primary,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    cursor: "pointer"
  }
}));
const FilterFooter = styled(Grid)(({ theme }) => ({
  fontFamily: "Poppins",
  color: theme.vars.palette.text.primary,
  padding: "20px 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderTop: `1px solid ${brandclub_colors.blueWhite}`,
  ".apply_button": {
    fontFamily: "Poppins",
    padding: "12px 100px",
    outline: "none",
    border: "none",
    background: theme.vars.palette.primary.main,
    color: theme.vars.palette.primary.contrastText,
    borderRadius: 999,
    fontSize: 16,
    fontWeight: 500
  }
}));
const FilterContentContainer = styled(Grid)(({ theme }) => ({
  color: theme.vars.palette.text.primary,
  fontSize: 16,
  fontWeight: 500,
  display: "flex",
  flexDirection: "column",
  padding: "0 30px",
  width: 690,
  overflowY: "scroll",
  ...brandclubStyles.customScrollbar,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    width: "100%",
    fontSize: 14
  },
  ".mobile_search_bar": {
    display: "none",
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      display: "block"
    }
  },
  ".row": {
    borderBottom: `1px solid ${brandclub_colors.blueWhite}`,
    padding: "30px 0px",
    "&:las-child": {
      borderBottom: `none`
    },
    ".row_title": {
      fontSize: 20,
      fontWeight: 600,
      marginBottom: 13,
      [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        fontSize: 14
      }
    },
    ".row_options": {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        gridTemplateColumns: "1fr"
      },
      gap: "8px",
      ".show_more": {
        textDecoration: "underline",
        cursor: "pointer"
      },
      ".option": {
        display: "flex",
        alignItems: "flex-start",
        ".option_label": {
          wordBreak: "break-word",
          paddingTop: "9px"
        }
      },
      ".option_reward": {
        display: "flex",
        flexWrap: "nowrap",
        [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
          gridColumnStart: 1,
          gridRowStart: 1
        },
        "&.right": {
          gridColumnStart: 1,
          gridRowStart: 1,
          gridRowEnd: 3,
          [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
            gridColumnStart: 1,
            gridRowStart: 1
          }
        },
        ".toggle_text": {
          marginLeft: 11,
          maxWidth: 200
        }
      }
    }
  }
}));
const FilterDialogContainer = styled("div")({
  height: "100%",
  display: "grid",
  gridTemplateRows: "70px 1fr 83px"
});
const getStaticFilters = () => ({
  RetailPrice: [
    { name: "0to25", displayName: "$0 - $25", enable: false },
    { name: "25to50", displayName: "$25 - $50", enable: false },
    { name: "50to100", displayName: "$50 - $100", enable: false },
    { name: "over100", displayName: "Over $100", enable: false }
  ],
  CampaignTypes: [
    {
      name: "purchaseRewardCampaign",
      displayName: "Purchase rewards",
      enable: false
    },
    {
      name: "affiliateLinkCampaign",
      displayName: "Affiliate rewards",
      enable: false
    }
  ]
});
const getDynamicFilters = (facetsResult) => {
  const res = {};
  const categoryFacets = _get(facetsResult, ["facets", "categoryId"], []);
  const subCategoryFacets = _get(facetsResult, ["facets", "subCategoryId"], []);
  const retailerFacets = _get(facetsResult, ["facets", "retailerId"], []);
  const brandFacets = _get(facetsResult, ["facets", "brandId"], []);
  if (!_isEmpty(categoryFacets)) {
    res.CategoryIds = categoryFacets.map((category) => ({
      name: category.categoryId,
      displayName: category.name,
      enable: false
    }));
  }
  if (!_isEmpty(subCategoryFacets)) {
    res.SubcategoryIds = subCategoryFacets.map((subCategory) => ({
      name: subCategory.subCategoryId,
      displayName: subCategory.name,
      enable: false
    }));
  }
  if (!_isEmpty(retailerFacets)) {
    res.RetailerIds = retailerFacets.map((retailer) => ({
      name: retailer.retailerId,
      displayName: retailer.name,
      enable: false
    }));
  }
  if (!_isEmpty(brandFacets)) {
    res.BrandIds = brandFacets.map((brand) => ({
      name: brand.brandId,
      displayName: brand.name,
      enable: false
    }));
  }
  return res;
};
const convertFilterStateToSearchParams = (filterState) => {
  let searchRoute = "";
  Object.entries(filterState).forEach(([filterName, filterValues]) => {
    filterValues == null ? void 0 : filterValues.forEach((option) => {
      if (option.enable) {
        searchRoute += `&${FilterParam[filterName]}=${option.name}`;
      }
    });
  });
  return searchRoute;
};
const convertSearchParamToFilterState = (searchParams, filterState) => {
  const params = {};
  searchParams.forEach((value, key) => {
    var _a;
    const decodedKey = decodeURIComponent(key);
    const decodedValue = decodeURIComponent(value);
    const filterKey = getFilterParamKeyFromValue(decodedKey);
    if (!filterKey) return;
    if (filterKey !== "VersionId" && filterKey !== "SiteId") {
      params[filterKey] = params[filterKey] || [];
      (_a = params[filterKey]) == null ? void 0 : _a.push(decodedValue);
    } else {
      params[filterKey] = decodedValue;
    }
  });
  const newFilterState = _cloneDeep(filterState);
  Object.entries(newFilterState).forEach(([filterName, filterValues]) => {
    filterValues == null ? void 0 : filterValues.forEach((state) => {
      var _a;
      if ((_a = params[filterName]) == null ? void 0 : _a.includes(`${state.name}`)) {
        state.enable = true;
      }
    });
  });
  return newFilterState;
};
const SelectOption = ({ checked = false, displayName = "", onChange }) => /* @__PURE__ */ jsxs("div", { className: "option", children: [
  /* @__PURE__ */ jsx(
    AppCheckbox,
    {
      checkboxProps: {
        checked,
        sx: (theme) => ({
          padding: "0px 19px 0px 0px",
          marginLeft: "-2px",
          "&.Mui-checked": {
            color: theme.vars.palette.text.primary
          }
        }),
        onChange
      },
      label: "",
      hideLabel: true
    }
  ),
  /* @__PURE__ */ jsx("div", { className: "option_label", children: displayName })
] });
const FilterRow = ({ title, options, onChange, ...props }) => {
  return /* @__PURE__ */ jsxs("div", { className: "row", children: [
    /* @__PURE__ */ jsx("div", { className: "row_title", children: title }),
    /* @__PURE__ */ jsxs("div", { className: "row_options", children: [
      !props.hideOptions && options.map((option) => {
        return /* @__PURE__ */ jsx(
          SelectOption,
          {
            onChange: (e, checked) => {
              onChange(option.name, checked);
            },
            checked: option == null ? void 0 : option.enable,
            displayName: option == null ? void 0 : option.displayName
          },
          option.name
        );
      }),
      props.children
    ] })
  ] });
};
const ShowMore = ({ onClick, className }) => /* @__PURE__ */ jsx(
  Button,
  {
    onClick,
    className: [className, "show_more"].filter(Boolean).join(" "),
    variant: "text",
    sx: {
      width: "fit-content",
      fontWeight: 500
    },
    children: "Show more"
  }
);
const FilterContent = ({ searchInput, applyFilter, setSearchInput, filterState, toggleFilterState }) => {
  var _a, _b, _c, _d;
  const [categoryIdsLimit, setCategoryIdsLimit] = useState(SHOW_MORE_INITIAL_LIMIT);
  const [subcategoryIdsLimit, setSubcategoryIdsLimit] = useState(SHOW_MORE_INITIAL_LIMIT);
  const [brandIdsLimit, setBrandIdsLimit] = useState(SHOW_MORE_INITIAL_LIMIT);
  const brandIds = useMemo(() => {
    var _a2;
    return (_a2 = filterState == null ? void 0 : filterState.BrandIds) == null ? void 0 : _a2.slice(0, brandIdsLimit);
  }, [filterState == null ? void 0 : filterState.BrandIds, brandIdsLimit]);
  const categoryIds = useMemo(() => {
    var _a2;
    return (_a2 = filterState == null ? void 0 : filterState.CategoryIds) == null ? void 0 : _a2.slice(0, categoryIdsLimit);
  }, [filterState == null ? void 0 : filterState.CategoryIds, categoryIdsLimit]);
  const subcategoryIds = useMemo(() => {
    var _a2;
    return (_a2 = filterState == null ? void 0 : filterState.SubcategoryIds) == null ? void 0 : _a2.slice(0, subcategoryIdsLimit);
  }, [filterState == null ? void 0 : filterState.SubcategoryIds, subcategoryIdsLimit]);
  const categoryShowMore = categoryIdsLimit < (((_a = filterState == null ? void 0 : filterState.CategoryIds) == null ? void 0 : _a.length) ?? 0);
  const subCategoryShowMore = subcategoryIdsLimit < (((_b = filterState == null ? void 0 : filterState.SubcategoryIds) == null ? void 0 : _b.length) ?? 0);
  const brandShowMore = brandIdsLimit < (((_c = filterState == null ? void 0 : filterState.BrandIds) == null ? void 0 : _c.length) ?? 0);
  const anyRewardChecked = !!((_d = filterState == null ? void 0 : filterState.CampaignTypes) == null ? void 0 : _d.find((type) => type == null ? void 0 : type.enable));
  return /* @__PURE__ */ jsxs(FilterContentContainer, { children: [
    /* @__PURE__ */ jsx("div", { className: "row mobile_search_bar", children: /* @__PURE__ */ jsx(
      TextField,
      {
        variant: "standard",
        placeholder: "Search products",
        value: searchInput,
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            applyFilter();
          }
        },
        onChange: (event) => setSearchInput(event.target.value),
        inputProps: { maxLength: 200 },
        InputProps: {
          disableUnderline: true,
          startAdornment: /* @__PURE__ */ jsx(SearchIcon, { color: "primary", sx: { marginRight: 1.25, fontSize: 13 } })
        },
        sx: (theme) => ({
          borderRadius: 17,
          height: 38,
          width: "100%",
          flex: 1,
          backgroundColor: brandclub_colors.blueWhite,
          "& div.MuiInput-root": {
            padding: "0 4px 0 14px",
            display: "flex",
            alignItems: "center",
            height: 38,
            "& input": {
              padding: 0,
              fontSize: 12,
              fontWeight: 500,
              fontFamily: "Poppins",
              color: theme.vars.palette.text.primary
            }
          }
        })
      }
    ) }),
    (filterState == null ? void 0 : filterState.CampaignTypes) && /* @__PURE__ */ jsx(
      FilterRow,
      {
        title: "Rewards",
        options: filterState.CampaignTypes,
        onChange: (name, enabled) => toggleFilterState("CampaignTypes", name, enabled),
        hideOptions: !anyRewardChecked,
        children: /* @__PURE__ */ jsxs("div", { className: `option_reward ${anyRewardChecked ? "right" : ""}`, children: [
          /* @__PURE__ */ jsx(
            BrandclubFilterSwitch,
            {
              sx: { margin: "2px 0px" },
              checked: anyRewardChecked,
              onChange: (_, checked) => toggleFilterState("CampaignTypes", null, checked)
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "toggle_text", children: "Only show products with reward offers" })
        ] })
      }
    ),
    (filterState == null ? void 0 : filterState.RetailPrice) && /* @__PURE__ */ jsx(
      FilterRow,
      {
        title: "Price",
        options: filterState.RetailPrice,
        onChange: (name, enabled) => toggleFilterState("RetailPrice", name, enabled)
      }
    ),
    (filterState == null ? void 0 : filterState.RetailerIds) && /* @__PURE__ */ jsx(
      FilterRow,
      {
        title: "Stores",
        options: filterState.RetailerIds,
        onChange: (name, enabled) => toggleFilterState("RetailerIds", name, enabled)
      }
    ),
    brandIds && /* @__PURE__ */ jsx(
      FilterRow,
      {
        title: "Brands",
        options: brandIds,
        onChange: (name, enabled) => toggleFilterState("BrandIds", name, enabled),
        children: brandShowMore && /* @__PURE__ */ jsx(
          ShowMore,
          {
            onClick: () => {
              setBrandIdsLimit((prevLimit) => prevLimit + SHOW_MORE_LIMIT);
            }
          }
        )
      }
    ),
    categoryIds && /* @__PURE__ */ jsx(
      FilterRow,
      {
        title: "Categories",
        options: categoryIds,
        onChange: (name, enabled) => toggleFilterState("CategoryIds", name, enabled),
        children: categoryShowMore && /* @__PURE__ */ jsx(
          ShowMore,
          {
            onClick: () => {
              setCategoryIdsLimit((prevLimit) => prevLimit + SHOW_MORE_LIMIT);
            }
          }
        )
      }
    ),
    subcategoryIds && /* @__PURE__ */ jsx(
      FilterRow,
      {
        title: "Subcategories",
        options: subcategoryIds,
        onChange: (name, enabled) => toggleFilterState("SubcategoryIds", name, enabled),
        children: subCategoryShowMore && /* @__PURE__ */ jsx(
          ShowMore,
          {
            onClick: () => {
              setSubcategoryIdsLimit((prevLimit) => prevLimit + SHOW_MORE_LIMIT);
            }
          }
        )
      }
    )
  ] });
};
const FilterDialog = ({
  onCloseSearchDropdown,
  searchInput,
  setSearchInput,
  brandId,
  navigate,
  open,
  onClose,
  persistentQueryParams,
  searchParams,
  pageContext,
  axios,
  routePrefix,
  facets
}) => {
  const [originFilterState, setOriginFilterState] = useState({});
  const [filterState, setFilterState] = useState({});
  const desktopView = useMediaQuery(`(min-width:${TABLET_SCREEN_SIZE}px)`);
  useEffect(() => {
    const generateCurrentFilters = async () => {
      let facetsResult;
      if (facets) {
        facetsResult = { products: [], facets };
      } else if (open) {
        const searchRequestBody = searchParamsToSearchFilters(searchParams, pageContext, brandId);
        facetsResult = await searchProductsRest(
          axios,
          searchRequestBody,
          { start: 0, size: 0 },
          {
            computeFacets: true,
            facetFieldNames: ["categoryId", "retailerId", "subCategoryId", "brandId"]
          },
          void 0
        );
      } else {
        return;
      }
      const originFilterState2 = {
        ...getStaticFilters(),
        ...getDynamicFilters(facetsResult)
      };
      const newFilterState = convertSearchParamToFilterState(searchParams, originFilterState2);
      setOriginFilterState(originFilterState2);
      setFilterState(newFilterState);
    };
    generateCurrentFilters();
  }, [searchParams, brandId, facets, open]);
  const toggleFilterState = (filterName, filterValue, enabled) => {
    var _a;
    const filterStateClone = _cloneDeep(filterState);
    (_a = filterStateClone[filterName]) == null ? void 0 : _a.forEach((option) => {
      if (filterValue === null || option.name === filterValue) {
        option.enable = enabled;
      }
    });
    setFilterState(filterStateClone);
  };
  const applyFilter = () => {
    let searchUrl = routePrefix + `/search?`;
    const searchParams2 = convertFilterStateToSearchParams(filterState);
    if (searchInput) {
      const encodedSearchInput = encodeURIComponent(searchInput.trim());
      searchUrl += `${FilterParam.TitleInclude}=${encodedSearchInput}`;
    }
    searchUrl += searchParams2;
    if (persistentQueryParams) {
      searchUrl += `&${persistentQueryParams}`;
    }
    onCloseSearchDropdown == null ? void 0 : onCloseSearchDropdown();
    navigate(searchUrl);
    setFilterState({});
    onClose();
  };
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      fullScreen: !desktopView,
      TransitionComponent: desktopView ? void 0 : Transition,
      onClose,
      PaperProps: {
        style: {
          height: desktopView ? 800 : "100%",
          maxWidth: "unset",
          boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px"
        }
      },
      style: { zIndex: 1500 },
      open,
      children: /* @__PURE__ */ jsxs(FilterDialogContainer, { children: [
        /* @__PURE__ */ jsxs(FilterHeader, { children: [
          /* @__PURE__ */ jsx("div", { className: "left", children: /* @__PURE__ */ jsx(CloseRoundedIcon, { color: "primary", onClick: onClose, sx: { cursor: "pointer" } }) }),
          /* @__PURE__ */ jsx("div", { className: "center", children: "Filter" }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "right",
              role: "button",
              style: { cursor: "pointer" },
              onClick: () => {
                setFilterState(originFilterState);
                setSearchInput("");
              },
              children: "Clear"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          FilterContent,
          {
            searchInput,
            setSearchInput,
            applyFilter,
            filterState,
            toggleFilterState
          }
        ),
        /* @__PURE__ */ jsx(FilterFooter, { children: /* @__PURE__ */ jsx("button", { className: "apply_button", onClick: applyFilter, children: "Apply" }) })
      ] })
    }
  );
};
export {
  FilterDialog
};
//# sourceMappingURL=FilterDialog.js.map
